import { useEffect, useRef } from 'react'
import { getPendingAttempts, deleteQueuedAttempt, pendingAttemptCount } from '../lib/offlineDb'
import { api } from '../lib/api'

// Flushes queued practice attempts when connectivity returns.
export function useOfflineSync() {
  const syncing = useRef(false)

  useEffect(() => {
    const flush = async () => {
      if (syncing.current) return
      const count = await pendingAttemptCount()
      if (count === 0) return

      syncing.current = true
      let syncedCount = 0
      try {
        const attempts = await getPendingAttempts()
        // Preserve original attempt order.
        const sorted = [...attempts].sort((a, b) => a.createdAt - b.createdAt)

        for (const attempt of sorted) {
          try {
            await api.post(`/questions/${attempt.questionId}/attempt`, {
              selected: attempt.selected,
              time_spent_ms: attempt.timeSpentMs,
            })
            await deleteQueuedAttempt(attempt.id)
            syncedCount += 1
          } catch {}
        }
      } finally {
        syncing.current = false
        if (syncedCount > 0) {
          window.dispatchEvent(new CustomEvent('tutor:offline-sync-complete', {
            detail: { syncedCount },
          }))
        }
      }
    }

    window.addEventListener('online', flush)
    if (navigator.onLine) flush()

    return () => window.removeEventListener('online', flush)
  }, [])
}
